/**
 * Suivi de l'historique de publication. « Publier maintenant » ENFILE un
 * travail (D9) : la publication n'entre dans l'historique qu'une fois le
 * worker démarré. Tant qu'une publication est `en_cours` — ou qu'un lancement
 * récent n'a pas encore produit la sienne — l'historique se rafraîchit seul,
 * sans qu'il faille recharger la page.
 */

export const INTERVALLE_SUIVI_PUBLICATION_MS = 3000;
/** Au-delà, un travail enfilé qui n'apparaît pas est laissé au rafraîchissement manuel. */
export const DELAI_SUIVI_PUBLICATION_MS = 120_000;

/** Marge pour l'écart d'horloge entre le navigateur et le serveur. */
const MARGE_HORLOGE_MS = 5000;

export function intervalleDeSuivi(
  publications: readonly { etat: 'en_cours' | 'reussie' | 'echouee'; debuteLe: string }[],
  lanceLe: number | null,
  maintenant: number,
): number | false {
  if (publications.some((publication) => publication.etat === 'en_cours')) {
    return INTERVALLE_SUIVI_PUBLICATION_MS;
  }
  if (lanceLe === null || maintenant - lanceLe > DELAI_SUIVI_PUBLICATION_MS) return false;
  const produite = publications.some(
    (publication) => Date.parse(publication.debuteLe) >= lanceLe - MARGE_HORLOGE_MS,
  );
  return produite ? false : INTERVALLE_SUIVI_PUBLICATION_MS;
}
